import { Box, Typography } from "@mui/material";

const EmptyState = () => (
  <Box
    sx={{
      py: 8,
      textAlign: "center",
      width: "100%",
    }}
  >
    <Typography
      variant="h6"
      color="text.secondary"
      sx={{ mb: 2, fontWeight: 500 }}
    >
      No books available in this category
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
      Check back later for new additions to our collection
    </Typography>
  </Box>
);

export default EmptyState;
